<template>
    <Card>
        <div>
            <h3>Datenquellen</h3>
            <table class="table table-hover">
                <thead>
                <tr>
                    <th>Typ</th>
                    <th class="text-center">Feldzuweisung</th>
                    <th class="text-right">Aktionen</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="source in sources">
                    <td class="text-uppercase pt-3">
                        <data-source :source="source.type"/>
                    </td>
                    <td class="text-center pt-3">
                        <i v-if="source.mapping_exists" class="fas fa-check"/>
                        <i v-else class="fas fa-times-circle"/>
                    </td>
                    <td class="text-right">
                        <button v-if="source.type === 'file' && source.mapping_exists" class="btn btn-xs btn-info"
                                @click="uploadFile(source.id)">
                            <i class="fas fa-upload mr-1"/>Datei hochladen
                        </button>

                        <a :href="$route('brands.product-import.start', {sourceId: source.id})"
                           v-if="source.mapping_exists" class="btn btn-xs btn-success">
                            <i class="fas fa-play mr-1"/>Import starten
                        </a>

                        <a :href="$route('brands.product-import.mapping', {sourceId: source.id})"
                           class="btn btn-xs btn-warning"><i class="fas fa-cog mr-1"/>Feldzuweisung</a>

                        <button @click="confirmDelete(source.id)"
                                class="btn btn-xs btn-danger">
                            <i class="fas fa-trash mr-1"/>Quelle entfernen
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="mt-3">
            <a :href="$route('brands.product-import.setup')" class="btn btn-primary"><i
                class="fas fa-plus-circle mr-1"/>Datenquelle hinzufügen</a>
        </div>
    </Card>
</template>

<script>
import DataSource from '@components/Brand/ProductImport/DataSource'
import Card from '@components/Cards/Card.vue'

export default {
    components: {
        Card,
        DataSource,
    },

    props: {
        sources: Array,
    },

    data() {
        return {
            formData: this.$inertia.form({
                feed: {},
            })
        }
    },

    methods: {
        uploadFile(sourceId) {
            Swal.fire({
                title: 'Bitte wählen Sie eine Datei aus',
                text: 'Erlaubte Formate: csv, tsv, txt, json.',
                type: 'info',
                input: 'file',
                showCancelButton: true,
                confirmButtonText: 'Import starten',
                cancelButtonText: this.__('actions.abort'),
            }).then(function(result) {
                if (result.isConfirmed) {
                    this.formData.transform(
                        (data) => ({
                            ...data,
                            feed: result.value
                        })
                    ).post(this.$route('brands.product-import.start.upload', {sourceId: sourceId}), {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                        onSuccess: () => {
                            this.$inertia.visit(this.$route('brands.product-import.start', {sourceId: sourceId}));
                        },
                        onError: (error) => {
                            console.log(error.response.data.errors)
                        }
                    });
                }
            })
        },

        confirmDelete(sourceId) {
            Swal.fire({
                title: 'Sind Sie sicher?',
                text: 'Die Datenquelle wird unwiderruflich entfernt.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-danger',
                cancelButtonClass: 'btn',
                confirmButtonText: 'Ja, Quelle entfernen',
                cancelButtonText: this.__('actions.abort'),
            }).then(function(result) {
                if (result.isConfirmed) {
                    this.$inertia.visit(this.$route('brands.product-import.delete', {sourceId: sourceId}));
                }
            })
        },
    },
}
</script>
